import { render } from "./refresh-icon.vue.js?vue&type=template&id=1c5750ac!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./refresh-icon.vue?vue&type=template&id=1c5750ac"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__